import {
  SetupChecklistItem,
  SetupChecklistItemId,
} from './compute-setup-checklist-items';

export const getSetupChecklistItemLabelKey = (
  item: SetupChecklistItem,
): string => {
  if (item.id === SetupChecklistItemId.FirstTask && item.useAlternateLabel) {
    return 'setup-checklist.item.first-task-alt';
  }

  if (item.id === SetupChecklistItemId.Habits && item.useAlternateLabel) {
    return 'setup-checklist.item.habits-alt';
  }

  return `setup-checklist.item.${item.id}`;
};
